/*------preparing image and roll over------*/
function GetLargeThumbPosition() {
  var xPosition = 0;
  var yPosition = 0;
  element = document.getElementById("large-thumb");
  
  while(element) {
    xPosition += (element.offsetLeft);
    yPosition += (element.offsetTop);
    element = element.offsetParent;
  }
  IMGPOSITOIN = [xPosition, yPosition];
  
  if((mobile && roomView)|| !mobile){
    document.getElementById("active-wrapper").addEventListener('mousemove', colorsDesktop, false);
    document.getElementById("active-wrapper").addEventListener('mouseout', colorsIni, false);
    document.getElementById("active-wrapper").addEventListener('touchstart', TapOrMove1, false);
    document.getElementById("active-wrapper").addEventListener('touchend', TapOrMove2, false);
    document.getElementById("active-wrapper").addEventListener('touchmove', colors, false);
  }else{
    document.getElementById("active-wrapper").removeEventListener('mousemove', colorsDesktop, false);
    document.getElementById("active-wrapper").removeEventListener('mouseout', colorsIni, false);
    document.getElementById("active-wrapper").removeEventListener('touchstart', TapOrMove1, false);
    document.getElementById("active-wrapper").removeEventListener('touchend', TapOrMove2, false);
    document.getElementById("active-wrapper").removeEventListener('touchmove', colors, false);
  }
  document.getElementById("paletteTarget").style.top = "50%";
  document.getElementById("paletteTarget").style.left = "50%";
  document.getElementById("paletteTarget").style.display = "none";
  
  if (!document.getElementById("colorCover")){
  	colorCover = document.createElement("div");
    colorCover.setAttribute("id", "colorCover");
    document.getElementById("roomClicker").insertBefore(colorCover, document.getElementById("active-wrapper"));
  }
  
  if(document.getElementById("active-wrapper").className == ""){
  	document.getElementsByTagName("palettes")[0].style.display = "none";
  }else{
  	document.getElementsByTagName("palettes")[0].style.display = "block";
    document.getElementById("colorCover").style.display = "none";
  }

};

function TapOrMove1(e){
  e.preventDefault();
  StartY = e.targetTouches[0].pageY;
  StartX = e.targetTouches[0].pageX;
  StartTime = Date.now();
}
function TapOrMove2(e){
  e.preventDefault();
  EndY = e.changedTouches[0].pageY;
  EndX = e.changedTouches[0].pageX;
  EndTime = Date.now();
  colorsIni();
  console.log ("time = " + (EndTime - StartTime))
  if (/*(StartX == EndX && StartY == EndY) || */ EndTime - StartTime < 300){
    showRoom(e); /* TAP */
  }
}




function colors(e){
  e.preventDefault();
  
  if(e.target.id == "paletteTarget"){
    e.dataTransfer.setData("Text", e.targetTouches[0].pageY);
  }
  imageX = e.targetTouches[0].pageX - IMGPOSITOIN[0];
  imageY = e.targetTouches[0].pageY - IMGPOSITOIN[1];
  colorsPostion()
}

function colorsDesktop(e){
  if(e.clientY == 0){
    return;
  }
  imageX = e.clientX - IMGPOSITOIN[0] + pageXOffset;
  imageY = e.clientY - IMGPOSITOIN[1] + pageYOffset;
  
  colorsPostion()
}


function colorsPostion(){
  //document.getElementById("paletteTarget").style.left=imageX +"px";
  //document.getElementById("paletteTarget").style.top=imageY +"px";
  
  TheX = Math.floor(imageX * Math.floor(document.getElementById("myCvs").offsetWidth) / document.getElementById("large-thumb").offsetWidth);
  TheY = Math.floor(imageY * Math.floor(document.getElementById("myCvs").offsetHeight) / document.getElementById("large-thumb").offsetHeight);

  if (TheY < 0 || TheY > document.getElementById("myCvs").offsetHeight){
    return false
  }
  
  p = ctx.getImageData(TheX, TheY, 1, 1).data;
  hex = "#" + ("000000" + rgbToHex(p[0], p[1], p[2])).slice(-6);
  
  if(document.getElementById("active-wrapper").className != ""){
  	document.getElementById("roomClicker").style.backgroundColor = hex;
  }else{
  	document.getElementById("colorCover").style.backgroundColor = hex;
    document.getElementById("colorCover").style.display = "block";
  }
}

function colorsIni(){
  document.getElementById("roomClicker").style.backgroundColor = "";
  document.getElementById("colorCover").style.backgroundColor = "";
  document.getElementById("colorCover").style.display = "none";
}

/*-------loading------*/

var img = new Image,
    //an image that has the proper CORS response header
    cvs = document.getElementById('myCvs'),
    ctx = cvs.getContext('2d');



img.crossOrigin = "*";
//img.setAttribute('crossOrigin','anonymous');
img.src = CanvasSrc;

img.onload = function() {
  ctx.drawImage( img, 0, 0 );
  var dataURL = cvs.toDataURL();
  height = Math.round(cvs.offsetHeight/2)
  width = cvs.offsetWidth;
  
  POINTS = Array();
  for(var k = 1; k <=5; k++){
    POINTS.push(Math.round(width*k/7))
  }
  
  
  MyPalette = document.getElementById("palette");
  for(var i = 0; i < 5; i++){
    p = ctx.getImageData(POINTS[i], height, 1, 1).data;
    hex = "#" + ("000000" + rgbToHex(p[0], p[1], p[2])).slice(-6);
    newSquare = document.createElement("div");
    newSquare.className = "paletteSquare"; 
    newSquare.style.backgroundColor = hex;
    newSquare.addEventListener("mouseover", function(){changeWallOn(this), false});
    newSquare.addEventListener("mouseout", changeWallOff, false);
    MyPalette.appendChild(newSquare)
  }
  
  /*---darker------------------*/  
  MyPalette = document.getElementById("paletteDark");
  for(var i = 0; i < 5; i++){
    p = ctx.getImageData(POINTS[i], height, 1, 1).data;
    hsl = rgb2hsl(p);
    //hsla(170, 50%, 45%, 1);
    darker = hsl[2] - 15;
    hslText = "hsla(" + hsl[0] + ", " + hsl[1] + "%, " + darker + "%, 1)"
    //console.log(hslText);
    newSquare = document.createElement("div");
    newSquare.className = "paletteSquare"; 
    newSquare.style.backgroundColor = hslText;
    newSquare.addEventListener("mouseover", function(){changeWallOn(this), false});
    newSquare.addEventListener("mouseout", changeWallOff, false);
    MyPalette.appendChild(newSquare)
  }
  
 
}

function changeWallOn(obj){
	document.getElementById("roomClicker").style.backgroundColor = obj.style.backgroundColor;
}
function changeWallOff(){
	document.getElementById("roomClicker").style.backgroundColor = "";
}

function rgbToHex(r, g, b) {
  if (r > 255 || g > 255 || b > 255)
    throw "Invalid color component";
  return ((r << 16) | (g << 8) | b).toString(16);
}


function rgb2hsl(rgbArr){
  var r1 = rgbArr[0] / 255;
  var g1 = rgbArr[1] / 255;
  var b1 = rgbArr[2] / 255;
  
  var maxColor = Math.max(r1,g1,b1);
  var minColor = Math.min(r1,g1,b1);
  //Calculate L:
  var L = (maxColor + minColor) / 2 ;
  var S = 0;
  var H = 0;
  if(maxColor != minColor){
    //Calculate S:
    if(L < 0.5){
      S = (maxColor - minColor) / (maxColor + minColor);
    }else{
      S = (maxColor - minColor) / (2.0 - maxColor - minColor);
    }
    //Calculate H:
    if(r1 == maxColor){
      H = (g1-b1) / (maxColor - minColor);
    }else if(g1 == maxColor){
      H = 2.0 + (b1 - r1) / (maxColor - minColor);
    }else{
      H = 4.0 + (r1 - g1) / (maxColor - minColor);
    }
  }
  
  L = L * 100;
  S = S * 100;
  H = H * 60;
  if(H<0){
    H += 360;
  }
  var result = [H, S, L];
  return result;
}


//resets cache on src of img if it comes back undefined, using a 1x1 blank gif dataURI
/*if ( img.complete || img.complete === undefined ) {
    img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    img.src = src;
}*/